import { createSelector } from 'reselect';
import { parentIssueEntitySelector } from '../../../common/state/selectors/issue-selector';

export const hasParentIssueSelector = createSelector(parentIssueEntitySelector, (parentIssue) =>
	Boolean(parentIssue && parentIssue.id),
);
